<section class="container-fluid" [ngClass]="{ 'bg-highlight': state.bg }">
  <div class="container-md p-0 pt-4">
    <div class="row flex-column">
      <ts-quick-nav class="col" [navigation_title]="state.navigation_title" />

      @if (state.page_title) {
        <div class="col col-9 col-lg-12 mt-3">
          <h2 class="my-0 display-2 line-clamp-2 lh-1">{{ state.page_title }}</h2>
        </div>
      }
    </div>
  </div>
</section>

@if (!!content) {
  <nav
    [ts-sticky-observer]
    [ngClass]="{
      'mb-3 bg-highlight': state.bg,
      'page-title-sticky': state.sticky
    }"
    (stick)="onStick($event)"
  >
    <ng-container *ngTemplateOutlet="content" />
  </nav>
}
